import React, { useState } from 'react';
import constate from 'constate';
import { POST_PAGE_TYPES } from '../constants/postPageTypes';

const usePostProvider = () => {
    const [currentPostPage, setCurrentPostPage] = useState(POST_PAGE_TYPES.INVITATIONS);

    return {
        currentPostPage,
        setCurrentPostPage,
    };
};

const [provider, hook] = constate(usePostProvider);

export const PostProvider = provider;

export const usePostContext = hook;

export const withPostProvider = Component => props => {
    return (
        <PostProvider>
            <Component {...props} />
        </PostProvider>
    );
};
